import { namespace } from 'vuex-class';
import { IEngagementVideoState } from './engagement-video.types';

export const EngagementVideo = namespace('video/engagementVideo');

export function getDefaultState(): IEngagementVideoState {
  return {
    loading: false,
    loaded: false,
    adding: false,
    addedVideo: null,
    videos: [],
  };
}

export enum EEngagementVideoAction {
  Add = 'add',
  AddSuccess = 'addSuccess',
  AddFailed = 'addFailed',
  Reset = 'reset',

  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',

  UploadVideoFromFile = 'uploadVideoFromFile',
  UploadVideoSuccess = 'uploadVideoSuccess',
  UploadVideoFailed = 'uploadVideoFailed',

  Remove = 'remove',
  RemoveSuccess = 'removeSuccess',
  RemoveFailed = 'removeFailed',

  UpdateVideo = 'updateVideo',
  UpdateVideoSuccess = 'updateVideoSuccess',
  UpdateVideoFailed = 'updateVideoFailed',

  UploadVideoFromUrl = 'uploadVideoFromUrl',

  Alert = 'alert',
}

export enum EEngagementVideoMutation {
  SetAdding = 'setAdding',
  SetVideo = 'setVideo',
  SetState = 'setState',
  SetVideos = 'setVideos',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  Remove = 'remove',
}
